import {usePrefetchAssetsHistory} from '@domain/assets'
import {usePrefetchMaterialsRecipes} from '@domain/materials'
import {dataTestId} from '@hconnect/uikit'
import {useUpmPlantContext} from '@hconnect/upm'
import {Box, Stack} from '@mui/material'
import React from 'react'

import {useSelectedTimeframe} from '../hooks'
import {SelectedForecastTypeProvider} from '../providers'

import {
  AssetCapacityCard,
  MonthlyProductionPlanningActions,
  ProductionSummaryCard
} from './monthlyPlanning'
import {PageProductionPlanningHeader} from './PageProductionPlanningHeader'

export const LayoutMonthlyPlanning: React.FC = () => {
  const {plantId: plantCode} = useUpmPlantContext()
  const {selectedTimeframe} = useSelectedTimeframe()
  if (!selectedTimeframe) {
    throw new Error('selectedTimeframe is not defined')
  }

  // prefetching required data
  usePrefetchAssetsHistory(plantCode, selectedTimeframe)
  usePrefetchMaterialsRecipes(plantCode)

  return (
    <Stack spacing={2} {...dataTestId('monthly_planning_layout')}>
      <PageProductionPlanningHeader
        plantCode={plantCode}
        actions={<MonthlyProductionPlanningActions />}
      />
      <Stack spacing={2} direction="row">
        <Box sx={{flex: 1}}>
          <SelectedForecastTypeProvider>
            <ProductionSummaryCard />
          </SelectedForecastTypeProvider>
        </Box>
        <Box sx={{flex: 1}}>
          <AssetCapacityCard plantCode={plantCode} />
        </Box>
      </Stack>
    </Stack>
  )
}
